import * as Yup from 'yup';
import { DictionaryWaterOrigin } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryWaterOrigin>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
